export enum AdpVoucherBatchType {    
    None = 0,
    Donor = 1,
    VoucherHolder = 2
}